import { render } from "./App.vue?vue&type=template&id=4c8aba1b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4c8aba1b&lang=css"
import "./App.vue?vue&type=style&index=1&id=4c8aba1b&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\ASRHAVELI\\attendance\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__